import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Tab, Tabs } from '@mui/material';
import StoreImages from './StoreImages';
import XHSContentGenerator from './XHSContentGenerator';
import VehicleModels from './VehicleModels';
import { API_ENDPOINTS } from '../config/api';

const XHSCombined = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [canManageVehicleModels, setCanManageVehicleModels] = useState(false);
  
  // Since this is the same tab, if user can access it, they can access both views
  // The route protection ensures they have xhs-content-generator permission
  
  // Determine initial view based on URL hash or default to generator
  const getInitialView = () => {
    const hash = location.hash;
    if (hash === '#models' && canManageVehicleModels) {
      return 'models';
    } else if (hash === '#generator') {
      return 'generator';
    } else if (hash === '#images') {
      return 'images';
    } else {
      // Default to generator view
      return 'generator';
    }
  };
  
  const [view, setView] = useState(() => getInitialView()); // 'images' or 'generator'

  // Update view when location changes
  useEffect(() => {
    const hash = location.hash;
    if (hash === '#models' && canManageVehicleModels) {
      setView('models');
    } else if (hash === '#generator') {
      setView('generator');
    } else if (hash === '#images') {
      setView('images');
    }
  }, [location.hash, canManageVehicleModels]);

  useEffect(() => {
    let cancelled = false;
    fetch(API_ENDPOINTS.VEHICLE_MODELS)
      .then(async (response) => {
        const data = await response.json();
        if (!cancelled) setCanManageVehicleModels(response.ok && data.success === true);
      })
      .catch(() => {
        if (!cancelled) setCanManageVehicleModels(false);
      });
    return () => { cancelled = true; };
  }, []);

  const handleViewChange = (_, nextView) => {
    navigate(`/xhs#${nextView}`);
  };

  return (
    <Box sx={{ width: '100%', height: '100%' }}>
      {canManageVehicleModels && view === 'models' && (
        <Box sx={{ px: { xs: 2, md: 3 }, pt: { xs: 2, md: 3 }, maxWidth: 1536, mx: 'auto' }}>
          <Tabs
            value={view}
            onChange={handleViewChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              minHeight: 46,
              borderBottom: '1px solid #e3eaf0',
              '& .MuiTab-root': { minHeight: 46, textTransform: 'none', fontWeight: 700 }
            }}
          >
            <Tab value="generator" label="Create content" />
            <Tab value="images" label="Image library" />
            <Tab value="models" label="Vehicle models" />
          </Tabs>
        </Box>
      )}
      <Box sx={{ width: '100%', height: '100%' }}>
        {view === 'images' && <StoreImages />}
        {view === 'generator' && <XHSContentGenerator canManageVehicleModels={canManageVehicleModels} />}
        {view === 'models' && canManageVehicleModels && <VehicleModels />}
      </Box>
    </Box>
  );
};

export default XHSCombined;

